export default angular
  .module('doxy.common.directives.dDynamicHtml', [])
  .directive('dDynamicHtml', function ($compile) {
    return {
      restrict: 'A',
      scope: false,
      link: function (scope, elem, attrs) {
        scope.$watch(attrs.dDynamicHtml, function (html) {
          elem.html(html);
          $compile(elem.contents())(scope);
        });
      },
    };
  }).name;
